import { type Mapper } from "./";
import type { OnboardingSchema, OnboardingSchemaDTO } from "@akina/domain";

export const onboardingSchemaMapper: Mapper<OnboardingSchema, OnboardingSchemaDTO> = {
  toDomain: (onboardingSchemaDTO: OnboardingSchemaDTO): OnboardingSchema => ({
    email: onboardingSchemaDTO.email,
    status: onboardingSchemaDTO.status,
    language: onboardingSchemaDTO.language,
    responseStatus: onboardingSchemaDTO.responseStatus,
  }),
  toDTO: (domain: OnboardingSchema): OnboardingSchemaDTO => ({
    email: domain.email,
    status: domain.status,
    language: domain.language,
    responseStatus: domain.responseStatus,
  }),
};
